import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireSurvey, UmpireSurveyAnswer} from '@tisa-group/models';

import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class SurveyService implements CrudService<UmpireSurvey> {
  constructor(readonly http: TisaUmpireHttpService) {}

  answer(answer: UmpireSurveyAnswer, params?: JsonApiParams) {
    return this.http
      .post('/surveys/user_answers', serialize({stuff: answer}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireSurvey[]>> {
    return this.http
      .get(`/surveys`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSurvey>> {
    return this.http
      .get(`/surveys/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  create(
    survey: Partial<UmpireSurvey>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSurvey>> {
    return this.http
      .post(`/surveys`, serialize({stuff: survey}), {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  update(
    survey: Partial<UmpireSurvey>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireSurvey>> {
    return this.http
      .patch(`/surveys/${survey.id}`, serialize({stuff: survey}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/surveys/${id}`);
  }
}
